/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export const SET_CHANNELS_TYPE = 'SET_CHANNELS_TYPE';
export const SET_CHANNEL_OPTIONS = 'SET_CHANNEL_OPTIONS';
export const SET_CHANNEL_OPTIONS_OVERLAY_CONTEXT = 'SET_CHANNEL_OPTIONS_OVERLAY_CONTEXT';
export const RESET_CATEGORIES_FILTER = 'RESET_CATEGORIES_FILTER';
